import { OrderPayment } from '@shared/payment'

export const sumDepositCharges = (deposits: OrderPayment[] = []) =>
  deposits.reduce(
    (acc, deposit) =>
      acc +
      (deposit.transactions ?? [])
        .filter((t) => t.type === 'CHARGE')
        .reduce((sum, t) => sum + (t.amount ?? 0) + (t.surcharge ?? 0) + (t.surchargeTax ?? 0), 0),
    0
  )
